<template>
    <div @keyup.enter="login" :style="style" v-show="islogin">
        <div v-show="isSysShow" style="width:100%;height:100%;padding: 10% 30%;">
            <div style="height: 100%;width: 100%;border: 1px solid #3f51b5;text-align: left;padding: 0 25px;  box-shadow: #3f51b5 10px 10px 30px 5px ; border-radius: 10px;background: #ccc;min-height: 340px;min-width: 250px;">
                <div style="font-size: 24px;padding:5px 0;height: 15%;">
                    <Divider style="" orientation="left">配置界面</Divider>
                </div>
                <div style="height: 75%;width: 100%;">
                    <div style="height:30px"><Checkbox v-model="openSvg" >启用svg绘制</Checkbox></div>
                    <div style="height:30px"><Checkbox v-model="openLocalCache">启用IndexDB高速缓存</Checkbox>   </div>
                    <div style="height:30px"><Checkbox v-model="clearCache">清除项目IndexDB高速缓存</Checkbox>   </div>
                    <div style="height:30px"><Checkbox v-model="openPlayback">启用历史回放组件</Checkbox>   </div>
                    
                </div>
                <div style="text-align: right;">
                    <Button type="success" @click="upDataDB">保存修改</Button>
                    <Button type="error" @click="sysClose">关闭窗口</Button>
                </div>
            </div>
        </div>
        <div v-show="isTheLogin">
            <div v-if="isLanguage" :style="{color:'#09ebecfa',float:'right',padding:'10px 20px 0 0',display:'flex'}">
                {{languageName}}
                <div v-for="item in languageList" :key="item.language">
                    <Divider type="vertical"/> 
                    <a @click="updataLanguage(item)">{{item.table}}</a>
                </div>
            </div>
            <div :style="loginDialog">
                <div v-show="islogoImg">
                    <img class="img" :src="logoImg"/>
                </div>
                <Icon title="设置" @click="sysShow" v-show="isSysButton" type="md-settings" style="position: absolute; right: -5%; font-size: 20px; color: #f9f5f5; cursor: pointer; z-index: 2000;"/>
                <div v-show="isPassWord">
                    <Tabs v-model="defaultLogin" class="ivu-customtabs">
                        <TabPane :label="titleSystem" name="SmartWorx"></TabPane>
                        <!-- <TabPane label="连接管理" name="webmaster"></TabPane> -->
                        <TabPane v-if="showAlarm" :label="titleAlarm" name="alarm"></TabPane>
                    </Tabs>
                    <Input v-model="account" :autofocus="autofocus" :placeholder="titleUser" prefix="ios-contact" style="width:100%"/>
                    <br><br>
                    <Input v-model="passWord" type="password" :placeholder="titlePassWord"  prefix="ios-lock"  style="width:100%"/>
                    <br><br>
                    <Button type="success" long @click="login">{{titleLogin}}</Button>
                    <br>
                    <br>
                    <a style="text-decoration: underline;" v-show="isViews" @click="onAuthCode" download="view.zip">{{mobileLogin}}</a>
                    <i style="color:#fff"  v-show="isView">|</i>
                    <a style="text-decoration: underline" v-show="isView" :href="downloadUrl" download="view.zip">{{titleDownload}}</a>
                </div>
                
                <div v-show="isAuthCode">
                    <Tabs v-model="defaultLogin" class="ivu-customtabs">
                        <TabPane :label="titleSystem" name="SmartWorx"></TabPane>
                        <!-- <TabPane label="连接管理" name="webmaster"></TabPane> -->
                        <TabPane v-if="showAlarm" :label="titleAlarm" name="alarm"></TabPane>
                    </Tabs>
                    <Input v-model="phoneCode" :autofocus="autofocus" :placeholder="inputPhoneCode" prefix="ios-phone-portrait" style="width:100%"/>
                    <br><br>
                    <div style="position: relative; width: 100%;">
                        <Input v-model="authCode" :placeholder="verificationCode" prefix="ios-lock" style="width:100%"/>
                        <Button style="width: 100px;position: absolute;right:0px;top: 0;" @click="getCode" :disabled="isGetSet">{{count}}</Button>
                    </div>
                    <br>
                    
                    <Button type="success" long @click="login">{{titleLogin}}</Button>
                    <br>
                    <br>
                    <a style="text-decoration: underline" v-show="isViews" @click="onPassWord" download="view.zip">{{userLogin}}</a>
                    <i style="color:#fff"  v-show="isView">|</i>
                    <a style="text-decoration: underline" v-show="isView" :href="downloadUrl" download="view.zip">{{titleDownload}}</a>
                </div>
            </div>
            <div class="signFoot">
                <p>
                    <a :href="titlehomepage" v-show="isTitleCompany">{{titleCompany}}</a>
                </p>
            </div>
        </div>
    </div>
</template>
<style>
    .img {
        position: relative;
        width:100%;
        height:auto;
    }
    .loginDialog {
        padding: 40px;
        position: absolute;
        left: 35%;
        top : 10%;
        width: 26%;
        height: 40%;
    }
    .signFoot {
        position: absolute;
        left: 44%;
        top : 95%;
    }
    .ivu-customtabs.ivu-tabs {
        color: #ffffff;
    }

    .ivu-customtabs .ivu-tabs-nav .ivu-tabs-tab-active {
        color: #09ebecfa;
    }
</style>
<script>
import md5 from 'js-md5';
import axios from 'axios';
import { ifError } from 'assert';
axios.defaults.withCredentials = true;
export default {
    name : "login",
    mounted : function(){
        this.$store.registerModule(['system','login'],{
            state : {
                $ : this
            }
        });
        window.onresize =()  =>{
            return (()=>{
                
            })()
        }
    },
    data : function(){
        return {
            isLanguage : false,
            showAlarm : true,
            downloadUrl: debugFWebView + "client/download/view.zip",
            islogin : false,
            logoImg:'../../static/logo.png' ,//图片
            account : "",
            passWord : "",
            style : {
                width : '100%',
                height: '100%',
                margin:"0px",
                padding:"0px",
                overflowX:"hidden",
                overflowY:"hidden",
                background : 'url(../../static/loginBc.png)',
                moBackgroundSize:"100% 100%",
                backgroundSize:"100% 100%"
            },
            onSuccess : null,
            autofocus : true,
            defaultLogin : "SmartWorx",
            socketId : "",
            languageName : "简体中文",
            languageList : [],
            titleKey : {
                homepage : "主页",
                system : "系统",
                alarm : "预警后台",
                user : "账号",
                passWord : "密码",
                download : "下载客户端",
                company : "北京力控元通科技有限公司",
                login : "登录"
            },
            titlehomepage : "主页",
            titleSystem : "系统",
            titleAlarm : "预警后台",
            titleUser : "账号",
            titlePassWord : "密码",
            titleDownload : "下载客户端",
            titleCompany : "北京力控元通科技有限公司",
            titleLogin : "登录",
            islogoImg: true,
            loginDialog :{},
            authCode:"",//验证码
            phoneCode:"",//手机号
            isAuthCode:false,//验证码显示
            isPassWord:true,//用户登录,
            isAuthSet:true,//是否可以输入
            isGetSet:false,//是否可以点击
            count: '获取验证码',
            timer: null,
            isSysShow:false,//是否显示配置界面
            isTheLogin:true,//显示登录
            userLogin:"用户名登录",
            mobileLogin:"手机号登录",
            inputPhoneCode:"输入手机号",
            verificationCode:"验证码",
            openSvg:false,
            openLocalCache:false,
            openPlayback:false,
            isView : true,//下载是否显隐
            isSysButton :true,//是否显示设置按钮
            isViews:true,//手机登录是否显隐
            isTitleCompany:true,//公司名称是否显隐
            clearCache:false //清除index高速缓存的表
        }
    },
    methods : {
        //验证手机号
        checkPhone : function(phone){
            if(!(/^[1](([3][0-9])|([4][5-9])|([5][0-3,5-9])|([6][5,6])|([7][0-8])|([8][0-9])|([9][1,8,9]))[0-9]{8}$/.test(phone))){ 
                this.$Message.error(this.$store.state.system.$.languageName == "ch" ?'手机号码有误！' : 'Wrong mobile phone number!');
                return true; 
            } else{
                return false;
            }
        },
        //验证码倒计时
        getCode : function(){
            if(this.checkPhone(this.phoneCode)) return;
            this.isAuthSet = false;//启用输入
            this.isGetSet = true;//禁用按钮
            var TIME_COUNT = 60;
            if (!this.timer) {
                this.count = TIME_COUNT;
                this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                    this.count--;
                    } else {
                    this.isGetSet = false;//启用按钮
                    this.count = this.$store.state.system.$.languageName == "ch" ?"获取验证码":"GETCODE"
                    clearInterval(this.timer);
                    this.timer = null;
                    }
                }, 1000)
            }
            //调用接口发送短信
            var url = window.debugFWebView+"requestAuthCode";
            axios.post(url,{
                    userName: this.phoneCode //手机号
                }).then(function(result){
                if(result.err){
                    this.$Message.error(result.err);
                }
            }.bind(this)).catch(function (error) {
                console.log(error);
            });
        },
        onAuthCode : function(){
            this.isAuthCode = true;
            this.isPassWord = false;
        },
        onPassWord : function(){
            this.isAuthCode = false;
            this.isPassWord = true;
        },
        //data传参， 是窗口json数据
        show : function(isShow,socketId,data){
            this.isLanguage = parseInt(data.isLanguage) ? true : false;
            //this.islogoImg =  data.logoShow ? true : false;
            this.showAlarm =  data.showAlarm ? true : false;
            this.islogoImg =  parseInt(data.logo) ? true : false;
            
            if(data.logSystem == undefined || data.logSystem != "0"){
                this.isSysButton = true;
            }else{
                this.isSysButton = false;
            }
            if(data.logPhone == undefined || data.logPhone != "0"){
                this.isViews = true;
            }else{
                this.isViews = false;
            }
            if(data.logDownload == undefined || data.logDownload != "0"){

                this.isView = true;
            }else{
                this.isView = false;
                
            }
            if(data.logCompany == undefined || data.logCompany != "0"){
                this.isTitleCompany = true;
            }else{
                this.isTitleCompany = false;
            }

            /**计算宽度居中 （100%-17%）/2 */
            data.loginTop = data.loginTop ?data.loginTop:"20";
            data.loginLeft = data.loginLeft ?data.loginLeft:"41";
            
            // isView : true,//下载是否显隐
            // isSysButton :true,//是否显示设置按钮
            // isViews:true,//手机登录是否显隐
            // isTitleCompany:true,//公司名称是否显隐
            
            this.loginDialog = {
                position: "absolute",
                left: data.loginLeft+"%",
                top : data.loginTop+"%",
                width: "17%",
                height: "40%"
            }
            this.setLanguageList();
            this.updataTiles();
            this.islogin = isShow ? true : false;
            if(this.islogin){
                this.passWord = "";
                this.socketId = socketId;
                this.$store.state.system.alarmCenter.$.show(false);
                this.$store.state.system.webmaster.$.show(false);
                this.$store.state.system.manager.$.closeAllView();
            }
            
        },
        //打开配置窗口
        sysShow : function(){
            this.isSysShow = true;
            this.isTheLogin = false;
            this.clearCache = false;
            //反选设置
            this.openSvg = this.$store.state.system.$.indexDB[0].isSvg ? true : false;
            this.openLocalCache = this.$store.state.system.$.indexDB[0].isLocalCache ? true : false;
            this.openPlayback = this.$store.state.system.$.indexDB[0].isOpenPlayback ? true : false;
            //this.$store.state.system.webmaster.$.show(true);
        },
        //关闭配置窗口
        sysClose : function(){
            this.isSysShow = false;
            this.isTheLogin = true;

        },
        //保存indexDB配置
        upDataDB : function(){
            if(this.clearCache){
                this.$Modal.confirm({
                    title: '是否清除高速缓存数据库？',
                    onOk: () => {
                        this.$Message.info(window.delIndexDBAll());
                        this.$store.state.system.$.indexDB[0].isSvg = false;
                        this.$store.state.system.$.indexDB[0].isLocalCache = false;
                        this.$store.state.system.$.indexDB[0].isOpenPlayback = false;
                        this.putIindeDB();
                        this.sysClose();
                    },
                    onCancel: () => {
                        this.clearCache = false;
                        this.$Message.info('取消');
                    }
                });
            }else{
                this.putIindeDB();
                this.sysClose();
            }
        },
        //更新indexDB 数据
        putIindeDB : function(){
            var transaction = window.systemDBId.transaction(["projectObject"], 'readwrite');
            // 通过事务来获取IDBObjectStore
            var store = transaction.objectStore("projectObject");
            // 往store表中添加数据
            var addPersonRequest = store.put({
                id: 1, 
                isSvg: this.openSvg,
                isLocalCache:this.openLocalCache,
                isOpenPlayback:this.openPlayback,
            });
            addPersonRequest.onsuccess = function (event) {
                console.log('数据更新成功');
            };
            addPersonRequest.onerror = function (event) {
                console.log('数据更新失败');
            }
            //重新获取
            var request = store.getAll();
            request.onsuccess = async function(event) {
                this.$store.state.system.$.indexDB = request.result; 
            }.bind(this);
        },
        waiting : function(){
            return new Promise((resolve)=>{
                this.onSuccess = resolve;
            });
        },
        login : function(){
            if(this.isPassWord){
                if(this.account == ""){
                    this.$Message.error(this.$store.state.system.$.languageName == "ch" ?'请输入账号！' : 'Please enter your account number!');
                    return;
                }else if(this.passWord == ""){
                    this.$Message.error(this.$store.state.system.$.languageName == "ch" ?"请输入密码！":"Please enter your password!");
                    return;
                }
            }else{
                //判断验证码
                if(this.phoneCode == ""){
                     this.$Message.error(this.$store.state.system.$.languageName == "ch" ?"请输入手机号":"Please input mobile phone number!");
                     return;
                }
                //判断验证码
                if(this.authCode == ""){
                     this.$Message.error(this.$store.state.system.$.languageName == "ch" ?"请输入验证码":"Please enter the verification code!");
                     return;
                }
                if(!(/^\d{4}$/.test(this.authCode))){ 
                        this.$Message.error(this.$store.state.system.$.languageName == "ch" ?"请正确输入验证码":"Please enter the verification code!");
                    return;
                }
                
            }   
            var url = window.debugFWebView;
            switch(this.defaultLogin){
                case "SmartWorx":
                    url += "/login";
                break;
                case "webmaster":
                    url += "/webmaster";
                break;
                case "alarm":
                    url += "/alarm";
                break;
                default:
                    url += "/login";
                break;
            }
            if(this.isPassWord){
                var data = {
                    userName: this.account,
                    passWord: md5(this.passWord),
                    socketId : this.socketId
                }
            }else{
                var data = {
                    userName: this.phoneCode,
                    authCode: this.authCode,
                    socketId : this.socketId
                }
            }
            axios.post(url,data).then((result)=>{
                if(result.data.err){
                    this.$Message.error(result.data.err);
                }else{
                    this.onSuccess({
                        userName : result.data.userName,
                        userLevel: result.data.userInfo.userLevel,
                        key : result.data.key,
                        type : this.defaultLogin,
                        data : result.data
                    });
                }
            }).catch((error)=> {
                console.log(error);
            });
            
        },
        updataTiles : function(){
            var temp = this.$store.state.system.$.getResource(this.titleKey.system);
            this.titleSystem = temp != undefined ? temp : this.titleSystem;

            temp = this.$store.state.system.$.getResource(this.titleKey.alarm);
            this.titleAlarm = temp != undefined ? temp : this.titleAlarm;

            temp = this.$store.state.system.$.getResource(this.titleKey.user);
            this.titleUser = temp != undefined ? temp : this.titleUser;

            temp = this.$store.state.system.$.getResource(this.titleKey.passWord);
            this.titlePassWord = temp != undefined ? temp : this.titlePassWord;

            temp = this.$store.state.system.$.getResource(this.titleKey.download);
            this.titleDownload = temp != undefined ? temp : this.titleDownload;

            temp = this.$store.state.system.$.getResource(this.titleKey.company);
            
            this.titleCompany = temp != undefined ? temp : this.titleCompany;

            temp = this.$store.state.system.$.getResource(this.titleKey.login);
            this.titleLogin = temp != undefined ? temp : this.titleLogin;

            temp = this.$store.state.system.$.getResource(this.titleKey.homepage);
            this.titlehomepage = temp != undefined ? temp : this.titlehomepage;

            if(this.$store.state.system.$.languageName == "en"){
                this.count = "SENDSMS";
                this.userLogin = "Login with user name";
                this.mobileLogin = "Mobile number login";
                this.inputPhoneCode = "Enter mobile phone number";
                this.verificationCode = "Verification Code";
            }else{
                this.count = "获取验证码";
                this.userLogin = "用户名登录";
                this.mobileLogin = "手机号登录";
                this.inputPhoneCode = "输入手机号";
                this.verificationCode = "验证码";
            }
            
        },
        updataLanguage(item){
            this.$store.state.system.$.languageName = item.language;
            this.setLanguageList();
            this.updataTiles();
        },
        setLanguageList(){
            this.languageList.splice(0);
            var current = this.$store.state.system.$.languageName;
            this.$store.state.system.$.languageList.map((item,i)=>{
                var table;
                if(item == "ch"){
                    table = this.$store.state.system.$.getResource("简体中文");
                    if(table == undefined){
                        table = "简体中文";
                    }
                }else if(item == "en"){
                    table = this.$store.state.system.$.getResource("English");
                    if(table == undefined){
                        table = "English";
                    }
                }else{
                    table = item;
                }
                this.languageList[i] = {
                    table : table,
                    language : item
                }
                if(item == current){
                   this.languageName = table; 
                }
            });
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/system/login.vue